<template>
  <card-modal :visible="visible" @close="close" :height="height" transition="zoom" ref="modal">
    <div class="mail-message-box" slot="body" :style="style">
      <h4 class="page-title">{{$t('page_title')}}</h4>
      <div class="popup-contents-box" v-html="set_url_link(props_data.mail)"></div>
      <div class="btn-box">
        <input type="button" class="new-add" @click="cancel" :value="$t('back')" />
      </div>
    </div>
  </card-modal>
</template>

<script>
import BaseModal from '@/lib/BasePopup';
export default {
  mixins: [BaseModal],
  name: 'MailMessagePopup',
  // ===========================================================================
  // language
  // ===========================================================================
  language: {
    'ja': {
      'page_title': 'チェックイン方法',
      'back': '戻る',
    },
    'en': {
      'page_title': 'How to check in',
      'back': 'back',
    }
  },
  // ===========================================================================
  // components
  // ===========================================================================
  components: {
  },
  // ===========================================================================
  // props
  // ===========================================================================
  props: {
    props_data: null,
  },
  // ===========================================================================
  // data
  // ===========================================================================
  data () {
    return {
      width: 'calc(100vw - 84px)',
      height: 'calc(100% - 28px)',
      // sex_type: ['', this.$t('sex1'), this.$t('sex2')],
      // height: `calc(${this.props_data.height}px - 80px)`,

      customer_info: {},
    };
  },
  // ===========================================================================
  // computed
  // ===========================================================================
  computed: {
  },
  // ===========================================================================
  // created
  // ===========================================================================
  created () {
  },
  // ===========================================================================
  // mounted
  // ===========================================================================
  mounted () {
  },
  // ===========================================================================
  // destroyed
  // ===========================================================================
  destroyed () {
  },
  // ===========================================================================
  // methods
  // ===========================================================================
  methods: {
    set_url_link(content) {
      const regexp = /(https?:\/\/.+)\n/ig;
      return content.replace(regexp, '<a href="$1" target="_brank">$1</a>\n');
    },
    ok () {
      this.$alert('info', 'テスト');
    },
    add () {
      alert('add');
    },
    del () {
      this.$alert('warning', '削除しますか？', this.add);
    },
    cancel () {
      this.close();
    },
  },
  // ===========================================================================
  // watch
  // ===========================================================================
  watch: {
  },
};
</script>

<style lang="scss">
.mail-message-box {
  background-color: #fefefe;
  padding: 32px;
  .popup-contents-box {
    margin: 20px 0;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    // height: calc(100vh - 255px);
    height: calc(100% - 113px);
    white-space: pre-wrap;
    word-break: break-all;
    .guide-p {
      height: 40px;
      overflow: auto;
    }
  }
  .sub-contents-box {
    margin-bottom: 0px;
    margin-right: 0px;
  }
  h4 {
    font-size: 18px;
    border-bottom: solid 1px #d3d4d8;
    width: 100%;
    padding: 0px 0px 5px 0px;
  }
  .new-add {
    color: #fefefe;
    display: block;
    text-align: center;
    padding: 8px 8px 8px 8px;
    font-size: 16px;
    text-decoration: none;
    border-radius: 3px;
    width: 150px;
    margin-left: 16px;
  }

  .btn-box {
    display: flex;
  }
  @media (max-width: 767px) {
    .customer-info {
      border: initial;
    }
    .flex {
      display: block;
      border: initial;
    }

    .new-add {
      width: 120px;
    }
  }
}
</style>
